import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useClienteAtual } from '../../empresasCliente-list/core/useClienteAtual'
import { SetorColumns } from './columns/_columns'
import { SetorAsoList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const SetorClienteTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const cliente = useClienteAtual()
  const { t } = useT()

  const columns = useMemo(() => SetorColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum setor encontrado para “${filters.nome.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={
        cliente?.nome ? `Nenhum setor cadastrado em ${cliente.nome}` : 'Nenhum setor cadastrado'
      }
      description='Use “Adicionar” para cadastrar o primeiro setor.'
    />
  )

  return (
    <CustomTable<SetorAsoList>
      id='kt_table_setores_cliente'
      ariaLabel='Setores'
      itemLabel={{ singular: 'setor', plural: 'setores' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
